import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled.div`
  background: ${myPalette.white.main};
  border-radius: 8px;
  box-shadow: 0 0 5px 0 rgba(0, 21, 70, 0.1);
  padding: 16px;
  margin: 16px 0 16px;
`
